'use client';

import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { brandColorAtom } from '@recoil/brandColor/brandColor.atom';
import { IGetBrandColorResponse } from 'ui/interface/brand/color/getBrandColor';

interface BrandColorInitializerProps {
  brandColor: IGetBrandColorResponse;
}

export const BrandColorInitializer = ({ brandColor }: BrandColorInitializerProps) => {
  const setBrandColor = useSetRecoilState(brandColorAtom);

  useEffect(() => {
    setBrandColor(brandColor);
  }, [brandColor, setBrandColor]);

  return null; // 이 컴포넌트는 렌더링하지 않음
};
